import { dew as _parseDew } from "./parse";
import { dew as _walkDew } from "./walk";
import { dew as _stringifyDew } from "./stringify";
import { dew as _unitDew } from "./unit";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var parse = _parseDew();
  var walk = _walkDew();
  var stringify = _stringifyDew();
  function ValueParser(value) {
    if (this instanceof ValueParser) {
      this.nodes = parse(value);
      return this;
    }
    return new ValueParser(value);
  }
  ValueParser.prototype.toString = function () {
    return Array.isArray(this.nodes) ? stringify(this.nodes) : "";
  };
  ValueParser.prototype.walk = function (cb, bubble) {
    walk(this.nodes, cb, bubble);
    return this;
  };
  ValueParser.unit = _unitDew();
  ValueParser.walk = walk;
  ValueParser.stringify = stringify;
  exports = ValueParser;
  return exports;
}